function cleanLabel(label) {
  return String(label || '').replace(/\s+/g, ' ').trim();
}

export function normalizeRegionalBadge(label, tone = 'slate') {
  const cleaned = cleanLabel(label);
  const upper = cleaned.toUpperCase();

  if (!cleaned) {
    return { label: '', tone, kind: 'severity' };
  }

  if (/^\d+\s*PTS?$/i.test(cleaned) || /^\d+\/\d+$/i.test(cleaned)) {
    return { label: cleaned, tone: 'slate', kind: 'score' };
  }

  if (upper === '↑') {
    return { label: 'Rising', tone: 'blue', kind: 'flag' };
  }

  if (upper.includes('MONITORING GAP')) {
    return { label: 'Monitoring Gap', tone: 'blue', kind: 'flag' };
  }

  if (upper === 'WORST ZONE') {
    return { label: 'Worst in Zone', tone: 'slate', kind: 'rank' };
  }

  if (upper.startsWith('WORST ')) {
    return { label: 'Worst in Circle', tone: 'slate', kind: 'rank' };
  }

  if (upper.startsWith('BEST ')) {
    return { label: 'Best in Circle', tone: 'slate', kind: 'rank' };
  }

  if (['GOOD', 'OK', 'MANAGED'].includes(upper)) {
    return { label: 'Managed', tone: 'good', kind: 'severity' };
  }

  if (['CRITICAL', 'CRISIS', 'CATASTROPHIC', 'FAIL'].includes(upper)) {
    return { label: 'Critical', tone: 'critical', kind: 'severity' };
  }

  if (['WATCH', 'PARTIAL', 'BELOW TARGET', 'BELOW', 'LOW', 'NEAR-MISS', 'HIGH'].includes(upper)) {
    return { label: 'Elevated', tone: 'warning', kind: 'severity' };
  }

  if (tone === 'green' || tone === 'good') {
    return { label: 'Managed', tone: 'good', kind: 'severity' };
  }

  if (tone === 'red' || tone === 'critical') {
    return { label: 'Critical', tone: 'critical', kind: 'severity' };
  }

  if (tone === 'orange' || tone === 'yellow' || tone === 'warning') {
    return { label: 'Elevated', tone: 'warning', kind: 'severity' };
  }

  return { label: cleaned, tone: 'slate', kind: 'flag' };
}
